import React, { Component } from "react";
import {Control, Form, Fieldset} from "react-redux-form";
import DatePick from './../forms/datepicker';
import {formatMoney} from "accounting-js";
import _ from 'lodash';

export default class TracingDispersions extends Component {
	render(){
		const { dispersions, match } = this.props;
		const { data } = dispersions;

		let mod1 = _.filter(data.budgets,{modality_id:1});
		let mod2 = _.filter(data.budgets,{modality_id:2});
		let mod3 = _.filter(data.budgets,{modality_id:3});

		let de = _.find(dispersions.permissions, (o) => {return o==='Create' || o==='Update'});
		let dd = _.find(dispersions.permissions, (o) => {return o==='Delete'});

		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="dispersions.data" onSubmit={(values => this._handleSubmit(values))} onSubmitFailed={(error) => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<fieldset className="fieldset">
							<legend>Seguimiento de la dispersión del recurso</legend>

							<div className="field">
								<div className="control">
									<label htmlFor="name" className="label">RESPONSABLE DEL SEGUIMIENTO, EVALUACIÓN Y CUMPLIMIENTO DE LA DISPERSIÓN DE</label>
									<label ><b>RECURSOS OTORGADOS:&nbsp;</b>{ !_.isEmpty(data.project) && !_.isEmpty(data.project.agency) && !_.isEmpty(data.project.agency.owner) ? `${data.project.agency.owner.name} ${data.project.agency.owner.last_name} ${data.project.agency.owner.slast_name}`: '---'}</label>
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="version_id" className="label">Año</label>
									<p>{ !_.isEmpty(data.project) && !_.isEmpty(data.project.agency) && !_.isEmpty(data.project.agency.version) ? data.project.agency.version.year : '---'}</p>
								</div>

								<div className="control is-expanded">
									<label className="label">Entidad</label>
									<p>{ !_.isEmpty(data.project) && !_.isEmpty(data.project.agency) && !_.isEmpty(data.project.agency.agenciable) ? data.project.agency.agenciable.name : '---'}</p>
								</div>
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="version_id" className="label">Recurso asignado</label>
									<p>{formatMoney(!_.isEmpty(dispersions.data.budget) ? dispersions.data.budget.total:0)}</p>
								</div>

								<div className="control is-expanded">
									<label className="label">Recurso transferido</label>
									<p>{formatMoney(!_.isEmpty(dispersions.data.budget) ? dispersions.data.budget.transfered:0)}</p>
								</div>

								<div className="control is-expanded">
									<label className="label">Recurso por transferir</label>
									<p>{formatMoney(!_.isEmpty(dispersions.data.budget) ? dispersions.data.budget.pending:0)}</p>
								</div>

								<div className="control is-expanded">
									<label className="label">Reintegro TESOFE</label>
									<p>{formatMoney(!_.isEmpty(dispersions.data.budget) ? dispersions.data.budget.tesofe:0)}</p>
								</div>
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="project_id" className="label">Instancia / proyecto:</label>
									<div className="select">
										<Control.select id="project_id" model=".project_id" ref="instance_id" value={dispersions.data.project_id ? dispersions.data.project_id:''}>
											<option value="">-- Seleccionar Instancia/proyecto --</option>
											{_.map(_.orderBy(dispersions.data.list, ['modality_id'], ['asc']), (row,k) => {
												return (
													<option value={row.project_id} key={k}>{`${row.modality_name} - ${row.agency_name} - ${row.agenciable_name}`}</option>
												)
											})}
										</Control.select>
									</div>
									{dispersions.data.project_id ?
										'':<small className="help has-text-danger">El proyecto es obligatorio</small>}
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="dispersion_date" className="label">Fecha de dispersion:</label>
									<Control.text id="dispersion_date" model=".dispersion_date" component={DatePick} className="input"/>
									{dispersions.data.dispersion_date ?
										'':<small className="help has-text-danger">La fecha es obligatoria</small>}
								</div>

								<div className="control">
									<label htmlFor="amount" className="label">Cantidad: </label>
									<input id="amount" type="text" className="input" readOnly value={this._showAmount()}/>
									{/*dispersions.amount ?
										'':<small className="help has-text-danger">El monto es obligatorio</small>*/}
								</div>

								<div className="control">
									<label htmlFor="method" className="label">Método de dispersión:</label>
									<div className="select">
										<Control.select id="method" model=".method" value={dispersions.data.method ? dispersions.data.method:''} changeAction={(model,value) => this._changeMethod(model,value)}>
											<option value="">-- Seleccionar metodo --</option>
											<option value="cheque">Cheque</option>
											<option value="transferencia electrónica">Transferencia electrónica</option>
											<option value="efectivo">Efectivo</option>
											<option value="reintegro tesofe">Reintegro TESOFE</option>
										</Control.select>
									</div>
									{dispersions.data.method ?
										'':<small className="help has-text-danger">El metodo es obligatorio</small>}
								</div>
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-info is-medium" onClick={() => this._addDispersion()} disabled={de ? (this._validAddDispersion()):true}>Agregar</button>
								</div>
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<legend>Documentos</legend>

							<Fieldset model=".documents" className="field is-grouped is-multiline">
								{_.map(_.filter(dispersions.documents_items, (o) => {return (o.modality_id === null || o.modality_id === (dispersions.data ? dispersions.data.modality_id:undefined))}),(item, d) => {
									let accepts = undefined;
									_.map(item.documents_types, (ext) => {
										accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
									})
									return (
										<div className="control" key={d}>
											<div className={`file`}>
												<label className="file-label">
													<Control.file className="file-input" model={`.${item.slug}`} id={`.${item.slug}`} accept={accepts} validateOn="change"/>
													<span className="file-cta">
			                                            <span className="file-icon"><i className="fa fa-upload" /></span>
			                                            <span className="file-label">{item.name}</span>
			                                        </span>
												</label>

											</div>
											{!_.isEmpty(dispersions.data) && !_.isEmpty(dispersions.data.documents) && dispersions.data.documents[item.slug] ?
												!_.isObject(dispersions.data.documents[item.slug]) ?
													<a href={dispersions.data.documents[item.slug]} className="help is-success" target="_blank">
														1 documento guardado <i className="fa fa-external-link" aria-hidden="true"/>
													</a> :
													<p className="help is-info">Un nuevo archivo cargado</p>
												: ''}
											{item.file_format ?
												<a href={item.file_format} className="help is-info" target="_blank">
													Descargar formato <i className="fa fa-external-link" aria-hidden="true"/>
												</a>:''}
										</div>
									)
								})}

								<div className="control">
									<button type="button" className="button is-info" onClick={() => this.props.projectDispersionsExport(match.params.modality, match.params.state, match.params.municipality)}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Generar Resumen</span>
									</button>
								</div>
							</Fieldset>
						</fieldset>

						{!_.isEmpty(mod1) ?
							<div className="columns">
								<div className="column">
									<br/>
									<p className="title is-6">Listado de proyectos - Modalidad I</p>

									<table className="table is-fullwidth project-goal-table">
										<thead>
										<tr>
											<th>#</th>
											<th>Instancia</th>
											<th>Fecha de dispersión</th>
											<th>Cantidad</th>
											<th>Acciones</th>
										</tr>
										</thead>
										<Fieldset model='.data' component='tbody' >
											{_.map(_.orderBy(mod1, ['dispersion_date']), (row, k) => {
												let rowIndex = _.findIndex(data.budgets, {project_id: _.toNumber(row.project_id)});
												return [
													<tr key={`row_1-${k}`}>
														<td className="goal-cell" style={{width:'10%'}} rowSpan={2}>
															<strong>{k+1}</strong>
														</td>
														<td >{`${row.agency_name} - ${row.agenciable_name}`}</td>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td><Control.text id={`dispersion_date_${row.projectId}`} model={`[${rowIndex}].dispersion_date`} component={DatePick} className="input"/></td>
															:<td >{row.dispersion_date}</td>}
														<td >{formatMoney(row.amount)}</td>
														<td style={{width:'10%'}} rowSpan={2}>
															<div className="field is-grouped">
																{this.state.editDispersion && this.state.projectId === row.project_id ?
																	<div className="control">
																		<button type="button" onClick={() => this._closeEdit()} className="button is-warning"><i className="fa fa-times" /></button>
																	</div>
																	:<div className="control">
																		<button type="button" className="button is-info" onClick={() => this._editDispersion(row.project_id)} disabled={de ? false:true}><i className="fa fa-edit" /></button>
																	</div>}
																	{dd ?
																	<div className="control">
																		<button type="button" onClick={() => this._removeBudget(row.project_id)} className="button is-danger"><i className="fa fa-trash" /></button>
																	</div> :''}
															</div>
														</td>
													</tr>,
													<tr key={`row_2-${k}`}>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label htmlFor={`method_${row.projectId}`} className="label">Método</label>
																<div className="select">
																	<Control.select id={`method_${row.projectId}`} model={`[${rowIndex}].method`} >
																		<option value="">-- Seleccionar metodo --</option>
																		<option value="cheque">Cheque</option>
																		<option value="transferencia electrónica">Transferencia electrónica</option>
																		<option value="efectivo">Efectivo</option>
																		<option value="reintegro tesofe">Reintegro TESOFE</option>
																	</Control.select>
																</div>
															</td>
															:<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label className="label">Método</label>
																{row.method}
															</td>}
													</tr>
												]
											})}
										</Fieldset>
									</table>
								</div>
							</div>
							:''}

						{!_.isEmpty(mod2) ?
							<div className="columns">
								<div className="column">
									<br/>
									<p className="title is-6">Listado de proyectos - Modalidad II</p>

									<table className="table is-fullwidth project-goal-table">
										<thead>
										<tr>
											<th>#</th>
											<th>Instancia</th>
											<th>Fecha de dispersión</th>
											<th>Cantidad</th>
											<th>Acciones</th>
										</tr>
										</thead>
										<Fieldset model='.data' component='tbody' >
											{_.map(_.orderBy(mod2, ['dispersion_date']), (row, k) => {
												let rowIndex = _.findIndex(data.budgets, {project_id: _.toNumber(row.project_id)});
												return [
													<tr key={`row_1-${k}`}>
														<td className="goal-cell" style={{width:'10%'}} rowSpan={2}>
															<strong>{k+1}</strong>
														</td>
														<td >{`${row.agency_name} - ${row.agenciable_name}`}</td>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td><Control.text id={`dispersion_date_${row.projectId}`} model={`[${rowIndex}].dispersion_date`} component={DatePick} className="input"/></td>
															:<td >{row.dispersion_date}</td>}
														<td >{formatMoney(row.amount)}</td>
														<td style={{width:'10%'}} rowSpan={2}>
															<div className="field is-grouped">
																{this.state.editDispersion && this.state.projectId === row.project_id ?
																	<div className="control">
																		<button type="button" onClick={() => this._closeEdit()} className="button is-warning"><i className="fa fa-times" /></button>
																	</div>
																	:<div className="control">
																		<button type="button" className="button is-info" onClick={() => this._editDispersion(row.project_id)} disabled={de ? false:true}><i className="fa fa-edit" /></button>
																	</div>}
																	{dd ?
																	<div className="control">
																		<button type="button" onClick={() => this._removeBudget(row.project_id)} className="button is-danger"><i className="fa fa-trash" /></button>
																	</div>:''}
															</div>
														</td>
													</tr>,
													<tr key={`row_2-${k}`}>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label htmlFor={`method_${row.projectId}`} className="label">Método</label>
																<div className="select">
																	<Control.select id={`method_${row.projectId}`} model={`[${rowIndex}].method`} >
																		<option value="">-- Seleccionar metodo --</option>
																		<option value="cheque">Cheque</option>
																		<option value="transferencia electrónica">Transferencia electrónica</option>
																		<option value="efectivo">Efectivo</option>
																		<option value="reintegro tesofe">Reintegro TESOFE</option>
																	</Control.select>
																</div>
															</td>
															:<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label className="label">Método</label>
																{row.method}
															</td>}
													</tr>
												]
											})}
										</Fieldset>
									</table>
								</div>
							</div>
							:''}

						{!_.isEmpty(mod3) ?
							<div className="columns">
								<div className="column">
									<br/>
									<p className="title is-6">Listado de proyectos - Modalidad III</p>

									<table className="table is-fullwidth project-goal-table">
										<thead>
										<tr>
											<th>#</th>
											<th>Instancia</th>
											<th>Fecha de dispersión</th>
											<th>Cantidad</th>
											<th>Acciones</th>
										</tr>
										</thead>
										<Fieldset model='.data' component='tbody' >
											{_.map(_.orderBy(mod3, ['dispersion_date']), (row, k) => {
												let rowIndex = _.findIndex(data.budgets, {project_id: _.toNumber(row.project_id)});
												return [
													<tr key={`row_1-${k}`}>
														<td className="goal-cell" style={{width:'10%'}} rowSpan={2}>
															<strong>{k+1}</strong>
														</td>
														<td >{`${row.agency_name} - ${row.agenciable_name}`}</td>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td><Control.text id={`dispersion_date_${row.projectId}`} model={`[${rowIndex}].dispersion_date`} component={DatePick} className="input"/></td>
															:<td >{row.dispersion_date}</td>}
														<td >{formatMoney(row.amount)}</td>
														<td style={{width:'10%'}} rowSpan={2}>
															<div className="field is-grouped">
																{this.state.editDispersion && this.state.projectId === row.project_id ?
																	<div className="control">
																		<button type="button" onClick={() => this._closeEdit()} className="button is-warning"><i className="fa fa-times" /></button>
																	</div>
																	:<div className="control">
																		<button type="button" className="button is-info" onClick={() => this._editDispersion(row.project_id)} disabled={de ? false:true}><i className="fa fa-edit" /></button>
																	</div>}
																	{dd ?
																	<div className="control">
																		<button type="button" onClick={() => this._removeBudget(row.project_id)} className="button is-danger"><i className="fa fa-trash" /></button>
																	</div> :''}
															</div>
														</td>
													</tr>,
													<tr key={`row_2-${k}`}>
														{this.state.editDispersion && this.state.projectId === row.project_id ?
															<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label htmlFor={`method_${row.projectId}`} className="label">Método</label>
																<div className="select">
																	<Control.select id={`method_${row.projectId}`} model={`[${rowIndex}].method`} >
																		<option value="">-- Seleccionar metodo --</option>
																		<option value="cheque">Cheque</option>
																		<option value="transferencia electrónica">Transferencia electrónica</option>
																		<option value="efectivo">Efectivo</option>
																		<option value="reintegro tesofe">Reintegro TESOFE</option>
																	</Control.select>
																</div>
															</td>
															:<td colSpan={/*row.method === 'reintegro tesofe' ? 2:*/3}>
																<label className="label">Método</label>
																{row.method}
															</td>}
													</tr>
												]
											})}
										</Fieldset>
									</table>
								</div>
							</div>
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/inicio')}>Regresar</button>
							</div>

							<div className="control">
								<Control.button model="dispersions.data" className="button is-large is-primary" disabled={de || dd ? false:true}>Guardar</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}

	constructor() {
		super();
		this.state = {
			projectId: undefined,
			editDispersion: false
		}
	}

	_handleSubmit(values) {
		let {modality,state,municipality} = this.props.match.params;
		//console.log('values', values);
		this.props.projectDispersionsSave(modality, state, municipality, values);
	}

	_changeMethod(model,value) {
		this.props.change(model,value);
		if(value !== 'reintegro tesofe'){
			this.props.change('dispersions.data.tesofe_refound',undefined);
		}
	}

	_validAddDispersion() {
		let { dispersions } = this.props;
		let response = true;
		if(!_.isEmpty(dispersions.data.project_id) && !_.isEmpty(dispersions.data.dispersion_date)  && !_.isEmpty(dispersions.data.method)){
			response = false;
		}
		return response;
	}

	_addDispersion() {
		let { dispersions } = this.props;

		let find = _.find(dispersions.data.list, {project_id: _.toNumber(dispersions.data.project_id)});
		let index = _.findIndex(dispersions.data.list, {project_id: _.toNumber(dispersions.data.project_id)});

		this.props.add('dispersions.data.budgets',{
			modality_id: find.modality_id,
			modality_name: find.modality_name,
			project_id: _.toNumber(dispersions.data.project_id),
			agency_name: find.agency_name,
			agenciable_name: find.agenciable_name,
			amount: _.toNumber(find.amount),
			dispersion_date: dispersions.data.dispersion_date,
			method: dispersions.data.method/*,
			tesofe_refound: budgets.tesofe_refound*/
		});
		this.props.remove('dispersions.data.list', index);
		this.props.change('dispersions.data.project_id', undefined);
		this.props.change('dispersions.data.dispersion_date', undefined);
		//this.props.change('project.budgets.amount', undefined);
		/*if(budgets.method === 'reintegro tesofe'){
			this.props.change('project.budgets.tesofe_refound',undefined);
		}*/
		this.props.change('dispersions.data.method', undefined);
	}

	_removeBudget(id) {
		let { dispersions } = this.props;

		let find = _.find(dispersions.data.budgets, {project_id: _.toNumber(id)});
		this.props.add('dispersions.data.list',{
			modality_id: find.modality_id,
			modality_name: find.modality_name,
			project_id: _.toNumber(find.project_id),
			agency_name: find.agency_name,
			agenciable_name: find.agenciable_name,
			amount: _.toNumber(find.amount)
		})

		let index = _.findIndex(dispersions.data.budgets, {project_id: _.toNumber(id)});
		this.props.remove('dispersions.data.budgets', index);
	}

	_showAmount() {
		let { dispersions } = this.props;
		let find = _.find(dispersions.data.list, {project_id: _.toNumber(dispersions.data.project_id)});
		if(find){
			return formatMoney( find.amount );
		}else {
			return formatMoney(0);
		}
	}

	_editDispersion(id) {
		this.setState({
			projectId: id,
			editDispersion: true
		})
	}

	_closeEdit(){
		this.setState({
			projectId: undefined,
			editDispersion: false
		})
	}

	/*_validDispersionTesofe(){
		let { dispersions } = this.props.project;
		let valid = false;
		let tesofe = _.filter(dispersions.data, {method: 'reintegro tesofe'})

		if(!_.isEmpty(tesofe)){
			_.map(tesofe, (row) => {
				_.mapKeys(row, (item, k) => {
					if(k ==='tesofe_refound' && _.isEmpty(item)){
						valid = true;
					}
				})
			})
		}

		return valid;

	}*/
}


// WEBPACK FOOTER //
// ./src/elements/tracing/dispersions.jsx